import { render } from "./DiarioEmocionalTermsAndConditions.vue?vue&type=template&id=0c069064"
import script from "./DiarioEmocionalTermsAndConditions.vue?vue&type=script&lang=js"
export * from "./DiarioEmocionalTermsAndConditions.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__